window.kgProductPageVariantId = false;
window.kgAddToCartFreeGifts = function () {
  if (
    !window.kgMainFreeGiftVariantId ||
    !window.kgOtherFreeGiftVariantId ||
    !window.kgProductPageVariantId
  )
    return;
  try {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: window.kgOtherFreeGiftVariantId,
            quantity: 1,
            properties: { _free_gift: true },
          },
          {
            id: window.kgMainFreeGiftVariantId,
            quantity: 1,
            properties: { _free_gift: true },
          },
          { id: window.kgProductPageVariantId, quantity: 1 }
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const kgCustomProductDiv = document.querySelector(".kg-popup-overlay");
        kgCustomProductDiv.classList.remove("kg-active");
        kgCustomProductDiv.style.display = "none";
        monster_refresh();
        console.log("Added to cart:", data);
      });
  } catch (error) {
    console.error("Error adding free gifts:", error);
  }
};
window.kgAddToCartOnlyMainProduct = function () {
  if (!window.kgProductPageVariantId) return;
  try {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [{ id: window.kgProductPageVariantId, quantity: 1 }],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const kgCustomProductDiv = document.querySelector(".kg-popup-overlay");
        // console.log('dddd');
        kgCustomProductDiv.classList.remove("kg-active");
        kgCustomProductDiv.style.display = "none";
        monster_refresh();
        console.log("Added to cart:", data);
      });
  } catch (error) {
    console.error("Error adding free gifts:", error);
  }
};
document.addEventListener("DOMContentLoaded", function () {
  const kgSizeSelect = document.getElementById("kgSizeSelect");
  const kgAddToCartFreeGiftsButton = document.querySelector(
    ".kg-add-to-cart-free-gifts-button"
  );
  const kgProductPageATCButton = document.querySelector(
    ".kg-add-to-cart-button"
  );
  const kgFreeGiftModalCloseButton = document.querySelector(".kg-close-link");
  if (kgFreeGiftModalCloseButton) {
    kgFreeGiftModalCloseButton.addEventListener("click", async function (e) {
      if (typeof window.kgAddToCartOnlyMainProduct === "function") {
        const kgAddToCartOnlyMainProductResponse =
          await window.kgAddToCartOnlyMainProduct();
        console.log(kgAddToCartOnlyMainProductResponse);
      }
    });
  }
  if (kgProductPageATCButton) {
    kgProductPageATCButton.addEventListener("click", async function (e) {
      // console.log('kkk');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const kgCustomProductDiv = document.querySelector(".kg-popup-overlay");
      console.log(kgCustomProductDiv);
      if (kgCustomProductDiv) {
        window.kgProductPageVariantId = Number(
          document.querySelector(".product-variant-id").value
        );
        kgCustomProductDiv.classList.add("kg-active");
        kgCustomProductDiv.style.display = "block";
      }
    });
  }
  // Function to update the selected color value display
  function updateSelectedColorDisplay() {
    const colorSelectedValue = document.querySelector(".kg-selected-value[data-option-name]");
    if (colorSelectedValue) {
      // Try to find checked swatch input first
      let colorInput = document.querySelector(
        ".kg-variant-picker--swatch .swatch-input__input:checked"
      );
      
      // If not found, try regular radio input
      if (!colorInput) {
        colorInput = document.querySelector(
          ".kg-variant-picker--swatch input[type='radio']:checked"
        );
      }
      
      if (colorInput) {
        // Get the color value from the input
        const colorValue = colorInput.value;
        
        // Try to get the label text (title attribute or text content)
        const colorLabel = colorInput.closest("label") || colorInput.nextElementSibling;
        let colorText = colorValue;
        
        if (colorLabel) {
          // Check for title attribute first (used in swatch-input)
          colorText = colorLabel.getAttribute("title") || colorLabel.textContent.trim() || colorValue;
        }
        
        // Update the selected value display
        colorSelectedValue.textContent = colorText;
      }
    }
  }
  
  // Function to update images based on color selection only
  function updateVariantImages() {
    const allVariantImages = document.querySelectorAll(".kg-variant-image");
    
    // Get selected color value (if any) - this determines which image to show
    const selectedColorInput = document.querySelector(
      ".kg-variant-picker--swatch input[type='radio']:checked, .kg-variant-picker--swatch .swatch-input__input:checked"
    );
    const selectedColorValue = selectedColorInput ? selectedColorInput.value : null;
    
    // Always show images based on color selection, ignore size selection for image display
    if (selectedColorValue) {
      // Color is selected - show image for that color only
      allVariantImages.forEach(function(img) {
        const colorValue = img.getAttribute("data-color-value");
        const variantId = img.getAttribute("data-variant-id");
        if (variantId && colorValue && colorValue === selectedColorValue) {
          // Show image that matches the selected color
          img.style.display = "block";
        } else if (variantId) {
          // Hide other color images
          img.style.display = "none";
        } else {
          // Images without data-variant-id should always be visible
          img.style.display = "block";
        }
      });
    } else {
      // No color selected - show first available image or all images without variant-id
      let imageShown = false;
      allVariantImages.forEach(function(img) {
        const variantId = img.getAttribute("data-variant-id");
        if (!variantId) {
          // Images without data-variant-id should always be visible
          img.style.display = "block";
          imageShown = true;
        } else if (!imageShown) {
          // Show first image with variant-id as fallback
          img.style.display = "block";
          imageShown = true;
        } else {
          img.style.display = "none";
        }
      });
    }
  }
  
  // Handle variant selection via color swatches and size pills
  function updateSelectedVariant() {
    const variantsData = document.getElementById("kg-product-variants");
    if (!variantsData) return;
    
    try {
      const variants = JSON.parse(variantsData.textContent);
      const selectedOptions = {};
      
      // Get all selected options (both swatches and pills)
      const allOptionInputs = document.querySelectorAll(
        ".kg-variant-picker input[type='radio']:checked"
      );
      
      const selectedOptionsByPosition = {};
      
      allOptionInputs.forEach(function(input) {
        let optionPosition = input.getAttribute("data-option-position");
        // If not found, try to extract from name attribute
        if (!optionPosition) {
          const nameMatch = input.name.match(/kgOption-[^-]+-(\d+)/);
          if (nameMatch) {
            optionPosition = nameMatch[1];
          }
        }
        if (optionPosition) {
          selectedOptionsByPosition[parseInt(optionPosition)] = input.value;
        }
      });
      
      // Find matching variant - need to match all selected options by position
      let matchedVariant = null;
      const selectedPositions = Object.keys(selectedOptionsByPosition);
      
      if (selectedPositions.length > 0) {
        for (let i = 0; i < variants.length; i++) {
          const variant = variants[i];
          let allOptionsMatch = true;
          
          // Check if variant matches ALL selected options by position
          selectedPositions.forEach(function(positionStr) {
            const position = parseInt(positionStr);
            const selectedValue = selectedOptionsByPosition[position];
            let optionMatches = false;
            
            // Match by option position
            if (position === 1 && variant.option1 && variant.option1 === selectedValue) {
              optionMatches = true;
            } else if (position === 2 && variant.option2 && variant.option2 === selectedValue) {
              optionMatches = true;
            } else if (position === 3 && variant.option3 && variant.option3 === selectedValue) {
              optionMatches = true;
            }
            
            if (!optionMatches) {
              allOptionsMatch = false;
            }
          });
          
          if (allOptionsMatch) {
            matchedVariant = variant;
            break;
          }
        }
      }
      
      // If no match found, try to get first available variant
      if (!matchedVariant) {
        matchedVariant = variants.find(function(v) {
          return v.available;
        }) || variants[0];
      }
      
      if (matchedVariant) {
        window.kgMainFreeGiftVariantId = matchedVariant.id;
        console.log("Updated Free Gift Variant ID:", window.kgMainFreeGiftVariantId);
        console.log("Matched Variant:", matchedVariant);
      } else {
        console.log("No variant matched. Selected options:", selectedOptionsByPosition);
      }
      
      // Update images based on color selection only
      updateVariantImages();
      
      // Update selected value display for color
      updateSelectedColorDisplay();
    } catch (error) {
      console.error("Error updating variant:", error);
    }
  }
  
  // Listen for changes on all option inputs (swatches and pills)
  const allOptionInputs = document.querySelectorAll(
    ".kg-variant-picker input[type='radio']"
  );
  
  // Also handle swatch inputs (they might use different class)
  const swatchInputs = document.querySelectorAll(
    ".kg-variant-picker .swatch-input__input"
  );
  
  // Combine all inputs (radio buttons and swatch inputs)
  const allInputs = Array.from(allOptionInputs).concat(Array.from(swatchInputs));
  
  if (allInputs.length > 0) {
    // Set initial variant and images
    updateSelectedVariant();
    
    // Listen for changes on all inputs
    allInputs.forEach(function(input) {
      input.addEventListener("change", function (e) {
        // Check if this is a color (swatch) input or size (pill) input
        const isSwatchInput = input.closest('.kg-variant-picker--swatch') !== null;
        const isPillInput = input.closest('.kg-variant-picker--pill') !== null;
        
        if (isSwatchInput) {
          // Color changed - update variant, images, and selected value display
          updateSelectedVariant();
          // Also update color display immediately
          updateSelectedColorDisplay();
        } else if (isPillInput) {
          // Size changed - only update variant (for cart), images stay the same
          updateSelectedVariant();
          // Note: updateVariantImages() is called inside updateSelectedVariant(),
          // but since color hasn't changed, the image display won't change
        } else {
          // Other inputs - update everything
          updateSelectedVariant();
        }
      });
    });
    
    // Also add click listeners for swatch inputs to ensure immediate update
    const swatchInputsOnly = document.querySelectorAll(".kg-variant-picker--swatch .swatch-input__input, .kg-variant-picker--swatch input[type='radio']");
    swatchInputsOnly.forEach(function(input) {
      input.addEventListener("click", function (e) {
        // Small delay to ensure the input is checked before updating
        setTimeout(function() {
          updateSelectedColorDisplay();
        }, 10);
      });
    });
    
    // Also listen for click events on pill inputs (kg-variant-radio) to ensure they trigger
    const pillInputs = document.querySelectorAll(".kg-variant-picker--pill .kg-variant-radio");
    pillInputs.forEach(function(input) {
      input.addEventListener("click", function (e) {
        // Small delay to ensure the radio button is checked before updating
        setTimeout(function() {
          updateSelectedVariant();
          // Images won't change because color hasn't changed
        }, 50);
      });
    });
    
    // Also listen on labels for pill inputs
    const pillLabels = document.querySelectorAll(".kg-variant-picker--pill .kg-variant-label");
    pillLabels.forEach(function(label) {
      label.addEventListener("click", function (e) {
        setTimeout(function() {
          updateSelectedVariant();
          // Images won't change because color hasn't changed
        }, 50);
      });
    });
  } else {
    // If no variant picker, show all images without data-variant-id
    const allVariantImages = document.querySelectorAll(".kg-variant-image");
    allVariantImages.forEach(function(img) {
      if (!img.getAttribute("data-variant-id")) {
        img.style.display = "block";
      }
    });
  }
  
  // Fallback for old select element (if it still exists)
  if (kgSizeSelect) {
    kgSizeSelect.addEventListener("change", function (e) {
      window.kgMainFreeGiftVariantId = Number(e.target.value);
      console.log(
        "Updated Free Gift Variant ID:",
        window.kgOtherFreeGiftVariantId
      );
    });
  }
  if (kgAddToCartFreeGiftsButton) {
    kgAddToCartFreeGiftsButton.addEventListener("click", async function (e) {
      if (typeof window.kgAddToCartFreeGifts === "function") {
        const kgAddToCartFreeGiftsResponse =
          await window.kgAddToCartFreeGifts();
        console.log(kgAddToCartFreeGiftsResponse);
      }
    });
  }
});
